export default "__VITE_ASSET__CMIIf_lF__"